module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAS0lEQVQ4jWM8deoUAx4gCJV6j0sJCz7dDAwM76A0Iy4FTAQMIAhGDaCCAaBo/E+EOpxqqOICnIkEyebRhERLAwhlZ5zlABgwMDAAAJKSCGVC3q9zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/shou2.png
// module id = 3ziu
// module chunks = 25